const actionDict = {
  38: 'Начало подключения',
  39: 'Окончание подключения',
};

export const action = (val) => actionDict[val];
